/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import { useThemeClassName } from '../../contexts/ThemeContext';

import styles from '../../../styles/partials/nhl-question-points-banner.module.scss';

const propTypes = {
    question: AppPropTypes.question,
    className: PropTypes.string,
};

const defaultProps = {
    question: null,
    className: null,
};

function NhlQuestionPointsBanner({ question, className }) {
    const themeClassName = useThemeClassName(styles);
    const { points, type } = question || {};
    const isTrivia = type === 'trivia';

    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            <div className={styles.inner}>
                {isTrivia ? (
                    <FormattedMessage
                        defaultMessage="Answer this bonus trivia question correctly to earn {count, plural, =0 {# pt} one {# pt} other {# pts}}."
                        description="NhlQuestionPointsBanner trivia question label"
                        values={{ count: points || 0 }}
                    />
                ) : (
                    <FormattedMessage
                        defaultMessage="Each shot you call correctly earns you {count, plural, =0 {# pt} one {# pt} other {# pts}}."
                        description="NhlQuestionPointsBanner standard question label"
                        values={{ count: points || 0 }}
                    />
                )}
            </div>
        </div>
    );
}

NhlQuestionPointsBanner.propTypes = propTypes;
NhlQuestionPointsBanner.defaultProps = defaultProps;

export default NhlQuestionPointsBanner;
